import { useState, useEffect } from 'react';

export default function Home() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState('전체');
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [selectedCourse, setSelectedCourse] = useState<any>(null);
  const [showAdminPanel, setShowAdminPanel] = useState(false);
  const [showReplyModal, setShowReplyModal] = useState(false);
  const [selectedInquiry, setSelectedInquiry] = useState<any>(null);
  const [replyContent, setReplyContent] = useState('');
  const [activeAdminTab, setActiveAdminTab] = useState('inquiries');
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState<any>(null);
  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [activeLoginTab, setActiveLoginTab] = useState('login');
  const [signupForm, setSignupForm] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    organization: '',
    department: '',
    position: '',
    phone: '',
    reason: ''
  });
  const [secrets, setSecrets] = useState({
    SUPABASE_URL: '',
    SUPABASE_ANON_KEY: '',
    RESEND_API_KEY: ''
  });
  const [inquiries, setInquiries] = useState([
    {
      id: 1,
      name: '김철수',
      email: 'kim@example.com',
      message: 'EMC 교육 과정에 대해 문의드립니다.',
      date: '2024-12-15',
      status: '미처리'
    },
    {
      id: 2,
      name: '이영희',
      email: 'lee@example.com',
      message: '집체교육 일정을 알고 싶습니다.',
      date: '2024-12-14',
      status: '처리완료'
    }
  ]);

  // 관리자 인증 관련 상태 추가
  const [showAdminLogin, setShowAdminLogin] = useState(false);
  const [adminLoginForm, setAdminLoginForm] = useState({ email: '', password: '' });
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);
  const [adminLoginAttempts, setAdminLoginAttempts] = useState(0);
  const [isAdminBlocked, setIsAdminBlocked] = useState(false);
  const [blockEndTime, setBlockEndTime] = useState<number | null>(null);

  // 관리자 계정 정보 (송이철 전용)
  const ADMIN_CREDENTIALS = {
    email: 'icsong@naver.com',
    password: '1a2s3d4f~~',
    authorizedUser: '송이철', // 유일한 관리자
    userId: 'admin_songicheol_001'
  };

  const MAX_LOGIN_ATTEMPTS = 3;
  const BLOCK_DURATION = 30 * 60 * 1000; // 30분

  // 회원가입 신청 목록 상태 추가
  const [signupRequests, setSignupRequests] = useState([
    {
      id: 1,
      name: '박민수',
      email: 'park@example.com',
      organization: '한국전력공사',
      department: '원자력발전처',
      position: '선임연구원',
      phone: '01012345678',
      requestDate: '2024-12-16',
      status: '대기중',
      reason: '원전 EMC 교육 수강을 위해 가입 신청합니다.'
    },
    {
      id: 2,
      name: '최영희',
      email: 'choi@example.com',
      organization: '한국원자력연구원',
      department: '원자력안전연구소',
      position: '책임연구원',
      phone: '01098765432',
      requestDate: '2024-12-15',
      status: '대기중',
      reason: '사이버보안 관련 교육과정 이수를 위해 회원가입을 신청합니다.'
    },
    {
      id: 3,
      name: '김기술',
      email: 'kim.tech@example.com',
      organization: '두산에너빌리티',
      department: '원전기술팀',
      position: '과장',
      phone: '01055557777',
      requestDate: '2024-12-14',
      status: '승인완료',
      reason: '품질보증 기술기준 교육 참여를 위해 신청합니다.',
      approvedDate: '2024-12-14',
      approvedBy: '관리자'
    }
  ]);

  // 로그인 상태 확인 및 복원
  useEffect(() => {
    // 로컬 스토리지에서 로그인 정보 복원
    const savedUser = localStorage.getItem('loggedInUser');
    if (savedUser) {
      try {
        const userData = JSON.parse(savedUser);
        // 승인된 사용자인지 확인
        const approvedUser = signupRequests.find(request => 
          request.email === userData.email && request.status === '승인완료'
        );
        
        if (approvedUser) {
          setUser(userData);
          setIsLoggedIn(true);
        } else {
          // 승인 상태가 변경되었거나 승인되지 않은 경우 로그아웃
          localStorage.removeItem('loggedInUser');
        }
      } catch (error) {
        localStorage.removeItem('loggedInUser');
      }
    }
  }, [signupRequests]);

  // 관리자 차단 상태 확인
  useEffect(() => {
    if (blockEndTime && Date.now() < blockEndTime) {
      setIsAdminBlocked(true);
      const timer = setTimeout(() => {
        setIsAdminBlocked(false);
        setBlockEndTime(null);
        setAdminLoginAttempts(0);
      }, blockEndTime - Date.now());
      
      return () => clearTimeout(timer);
    } else if (blockEndTime && Date.now() >= blockEndTime) {
      setIsAdminBlocked(false);
      setBlockEndTime(null);
      setAdminLoginAttempts(0);
    }
  }, [blockEndTime]);

  // 관리자 로그인 처리
  const handleAdminLogin = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (isAdminBlocked) {
      const remainingTime = Math.ceil((blockEndTime! - Date.now()) / 1000 / 60);
      alert(`보안상 계정이 차단되었습니다. ${remainingTime}분 후 다시 시도해주세요.`);
      return;
    }
    
    if (adminLoginForm.email === ADMIN_CREDENTIALS.email && 
        adminLoginForm.password === ADMIN_CREDENTIALS.password) {
      setIsAdminAuthenticated(true);
      setShowAdminLogin(false);
      setShowAdminPanel(true);
      setAdminLoginForm({ email: '', password: '' });
      setAdminLoginAttempts(0);
      
      // 관리자 로그인 로그 기록 (송이철 전용)
      console.log(`[ADMIN LOGIN SUCCESS] 관리자: ${ADMIN_CREDENTIALS.authorizedUser} - 시간: ${new Date().toISOString()}, IP: ${window.location.hostname}`);
      alert(`${ADMIN_CREDENTIALS.authorizedUser}님, 관리자 인증이 완료되었습니다.`);
    } else {
      const newAttempts = adminLoginAttempts + 1;
      setAdminLoginAttempts(newAttempts);
      
      // 실패 로그 기록 (무단 접근 시도)
      console.log(`[UNAUTHORIZED ACCESS ATTEMPT] 시도 ${newAttempts}/${MAX_LOGIN_ATTEMPTS} - 시간: ${new Date().toISOString()}, 입력 이메일: ${adminLoginForm.email}, 권한자: ${ADMIN_CREDENTIALS.authorizedUser} ONLY`);
      
      if (newAttempts >= MAX_LOGIN_ATTEMPTS) {
        setIsAdminBlocked(true);
        setBlockEndTime(Date.now() + BLOCK_DURATION);
        alert(`관리자 계정 정보가 올바르지 않습니다.\n\n⚠️ 중요 알림: 이 시스템의 관리자 권한은 ${ADMIN_CREDENTIALS.authorizedUser}님만 보유합니다.\n무단 접근 시도로 인해 30분간 접근이 차단됩니다.\n\n모든 접근 시도가 기록되며, 지속적인 무단 접근은 법적 조치의 대상이 됩니다.`);
        setShowAdminLogin(false);
      } else {
        alert(`⚠️ 접근 권한이 없습니다.\n\n관리자 권한은 오직 ${ADMIN_CREDENTIALS.authorizedUser}님만 보유합니다.\n올바른 관리자 정보를 입력해주세요.\n\n남은 시도 횟수: ${MAX_LOGIN_ATTEMPTS - newAttempts}회`);
      }
      
      setAdminLoginForm({ email: '', password: '' });
    }
  };

  // 관리자 로그아웃 처리
  const handleAdminLogout = () => {
    setIsAdminAuthenticated(false);
    setShowAdminPanel(false);
    console.log(`[ADMIN LOGOUT] 관리자: ${ADMIN_CREDENTIALS.authorizedUser} - 시간: ${new Date().toISOString()}`);
    alert(`${ADMIN_CREDENTIALS.authorizedUser}님이 관리자에서 로그아웃되었습니다.`);
  };

  // 관리자 패널 열기 (인증 확인)
  const openAdminPanel = () => {
    if (isAdminBlocked) {
      const remainingTime = Math.ceil((blockEndTime! - Date.now()) / 1000 / 60);
      alert(`보안상 계정이 차단되었습니다. ${remainingTime}분 후 다시 시도해주세요.\n\n⚠️ 관리자 권한: ${ADMIN_CREDENTIALS.authorizedUser}님 전용`);
      return;
    }
    
    if (isAdminAuthenticated) {
      setShowAdminPanel(true);
    } else {
      setShowAdminLogin(true);
    }
  };

  const loadInquiries = async () => {
    try {
      const response = await fetch('https://readdy.ai/api/form/d3m4h9k45u2jkf5ftssg/data', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        const data = await response.json();
        if (data && data.length > 0) {
          const formattedData = data.map((item: any, index: number) => ({
            id: inquiries.length + index + 1,
            name: item.name || '이름 없음',
            email: item.email || '이메일 없음',
            message: item.message || '내용 없음',
            date: new Date(item.created_at || Date.now()).toLocaleDateString('ko-KR'),
            status: '미처리'
          }));
          
          setInquiries([...inquiries, ...formattedData]);
        }
      }
    } catch (error) {
      console.log('문의 데이터를 불러오는 중 오류가 발생했습니다:', error);
    }
  };

  // 시크릿 저장 함수
  const saveSecrets = () => {
    localStorage.setItem('admin_secrets', JSON.stringify(secrets));
    alert('시크릿 정보가 저장되었습니다.');
  };

  // 시크릿 로드 함수
  const loadSecrets = () => {
    const savedSecrets = localStorage.getItem('admin_secrets');
    if (savedSecrets) {
      setSecrets(JSON.parse(savedSecrets));
    }
  };

  // 회원가입 승인 처리
  const approveSignupRequest = (requestId: number) => {
    setSignupRequests(prev => prev.map(request => 
      request.id === requestId 
        ? { 
            ...request, 
            status: '승인완료',
            approvedDate: new Date().toLocaleDateString('ko-KR'),
            approvedBy: '관리자'
          }
        : request
    ));
    
    // 승인된 사용자가 현재 로그인 중인 경우 상태 업데이트
    const approvedRequest = signupRequests.find(req => req.id === requestId);
    if (approvedRequest && user && user.email === approvedRequest.email) {
      const updatedUser = {
        ...user,
        status: '승인완료'
      };
      setUser(updatedUser);
      localStorage.setItem('loggedInUser', JSON.stringify(updatedUser));
    }
    
    alert('회원가입이 승인되었습니다. 승인 알림 이메일이 발송됩니다.');
  };

  // 회원가입 거부 처리
  const rejectSignupRequest = (requestId: number) => {
    const reason = prompt('거부 사유를 입력해주세요:');
    if (reason) {
      setSignupRequests(prev => prev.map(request => 
        request.id === requestId 
          ? { 
              ...request, 
              status: '거부됨',
              rejectedDate: new Date().toLocaleDateString('ko-KR'),
              rejectedBy: '관리자',
              rejectionReason: reason
            }
          : request
      ));
      
      // 거부된 사용자가 현재 로그인 중인 경우 강제 로그아웃
      const rejectedRequest = signupRequests.find(req => req.id === requestId);
      if (rejectedRequest && user && user.email === rejectedRequest.email) {
        handleLogout();
        alert('회원가입이 거부되어 로그아웃됩니다.');
        return;
      }
      
      alert('회원가입이 거부되었습니다. 거부 알림 이메일이 발송됩니다.');
    }
  };

  // 회원가입 처리
  const handleSignup = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // 비밀번호 확인
    if (signupForm.password !== signupForm.confirmPassword) {
      alert('비밀번호가 일치하지 않습니다.');
      return;
    }

    // 비밀번호 길이 확인
    if (signupForm.password.length < 6) {
      alert('비밀번호는 6자 이상이어야 합니다.');
      return;
    }

    const formData = new FormData();
    Object.entries(signupForm).forEach(([key, value]) => {
      if (key !== 'confirmPassword') {
        formData.append(key, value);
      }
    });

    try {
      const response = await fetch('https://readdy.ai/api/form/d3qslr7sc9mmlub0e930', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString()
      });

      if (response.ok) {
        alert('회원가입 신청이 완료되었습니다. 관리자 승인 후 이메일로 안내드리겠습니다.');
        
        // 회원가입 신청 목록에 추가
        const newRequest = {
          id: signupRequests.length + 1,
          name: signupForm.name,
          email: signupForm.email,
          organization: signupForm.organization,
          department: signupForm.department,
          position: signupForm.position,
          phone: signupForm.phone,
          requestDate: new Date().toLocaleDateString('ko-KR'),
          status: '대기중',
          reason: signupForm.reason
        };
        setSignupRequests([...signupRequests, newRequest]);
        
        setSignupForm({
          name: '',
          email: '',
          password: '',
          confirmPassword: '',
          organization: '',
          department: '',
          position: '',
          phone: '',
          reason: ''
        });
        setShowLoginModal(false);
        setActiveLoginTab('login');
      } else {
        alert('회원가입 신청 중 오류가 발생했습니다. 다시 시도해주세요.');
      }
    } catch (error) {
      alert('회원가입 신청 중 오류가 발생했습니다. 다시 시도해주세요.');
    }
  };

  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
    if (showAdminPanel) {
      loadInquiries();
      loadSecrets();
    }
  }, [showAdminPanel]);

  const courses = [
    {
      id: 1,
      category: '전자기적합성',
      title: 'EMC 01 EMI RFI 기본 개념',
      description: '전자기 간섭과 무선 주파수 간섭의 기본 개념 학습',
      videoId: '_BGbAxyyZk8',
      isPaid: true,
      price: 10000
    },
    {
      id: 2,
      category: '전자기적합성',
      title: 'EMC 02 IEC 62003 2020 해설',
      description: 'IEC 62003:2020 표준 상세 해설 과정',
      videoId: 'x0-JBP1izCk',
      isPaid: true,
      price: 10000
    },
    {
      id: 3,
      category: '전자기적합성',
      title: 'EMC 03 체코 원전 EMC CE 마킹 요건',
      description: '체코 원자력발전소 EMC CE 마킹 요구사항',
      videoId: 'yP9IQRgKKUQ',
      isPaid: true,
      price: 10000
    },
    {
      id: 4,
      category: '전자기적합성',
      title: 'EMC 05 대용량 전기기기의 CE101 시험 방안',
      description: '대용량 전기기기 CE101 시험 방법론',
      videoId: 'f4XpCLvc3LE',
      isPaid: true,
      price: 10000
    },
    {
      id: 5,
      category: '전자기적합성',
      title: 'EMC 06 원전 전자파 환경 E3 측정',
      description: '원자력발전소 전자파 환경 E3 측정 기법',
      videoId: 'WPMkD-y0e6Y',
      isPaid: true,
      price: 10000
    },
    {
      id: 6,
      category: '전자기적합성',
      title: 'EMC-07 냉동기 원거리 펌프 부하 구성 방안',
      description: '냉동기 원거리 펌프 부하 구성 방안에 대한 전문 교육과정',
      videoId: '4X0mXo8Z64w',
      isPaid: true,
      price: 10000
    },
    {
      id: 7,
      category: '품질보증',
      title: 'QA 004 품질보증 기술기준과 규제요건',
      description: '품질보증 기술기준 및 규제 요구사항 해설',
      videoId: 'BxG-ENyYo38',
      isPaid: true,
      price: 10000
    },
    {
      id: 8,
      category: '용접 비파괴',
      title: 'WN 001 ASNT LT 레벨 3 시험문지',
      description: 'ASNT 액체침투탐상 레벨 3 시험 대비',
      videoId: 'T87T7yyILHE',
      isPaid: true,
      price: 10000
    },
    {
      id: 9,
      category: '전기표준',
      title: '전기표준 NEMA 외함 보호등급 해설',
      description: 'NEMA 외함 보호등급 기준 상세 해설',
      videoId: 'nQ3nfDXhyZ0',
      isPaid: true,
      price: 10000
    },
    {
      id: 10,
      category: '전기표준',
      title: '전기접지 기술기준에 따른 접지 요건 일문 강좌',
      description: '전기접지 기술기준 및 접지 요구사항',
      videoId: '41X3y6sz-5A',
      isPaid: true,
      price: 10000
    }
  ];

  const categories = ['전체', '전자기적합성', '품질보증', '용접 비파괴', '전기표준', '사이버보안'];

  const filteredCourses = activeFilter === '전체' 
    ? courses 
    : courses.filter(course => course.category === activeFilter);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  const handleContactSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d3m4h9k45u2jkf5ftssg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString()
      });

      if (response.ok) {
        alert('문의가 접수되었습니다. 빠른 시일 내에 답변드리겠습니다.');
        form.reset();
        
        const newInquiry = {
          id: inquiries.length + 1,
          name: formData.get('name') as string,
          email: formData.get('email') as string,
          message: formData.get('message') as string,
          date: new Date().toLocaleDateString('ko-KR'),
          status: '미처리'
        };
        setInquiries([...inquiries, newInquiry]);
      } else {
        alert('문의 접수 중 오류가 발생했습니다. 다시 시도해주세요.');
      }
    } catch (error) {
      alert('문의 접수 중 오류가 발생했습니다. 다시 시도해주세요.');
    }
  };

  const openVideoModal = (course: any) => {
    if (course.isPaid) {
      // 유료 강좌인 경우 결제 페이지로 이동
      window.REACT_APP_NAVIGATE('/video-payment');
    } else {
      // 무료 강좌인 경우 바로 재생
      setSelectedCourse(course);
    }
  };

  const closeVideoModal = () => {
    setSelectedCourse(null);
  };

  // 답변 모달 열기
  const openReplyModal = (inquiry: any) => {
    setSelectedInquiry(inquiry);
    setReplyContent('');
    setShowReplyModal(true);
  };

  // 답변 모달 닫기
  const closeReplyModal = () => {
    setShowReplyModal(false);
    setSelectedInquiry(null);
    setReplyContent('');
  };

  // 답변 전송
  const sendReply = async () => {
    if (!replyContent.trim()) {
      alert('답변 내용을 입력해주세요.');
      return;
    }

    try {
      // 임시로 답변 전송 성공 처리 (실제 이메일 전송은 Supabase 연결 후 가능)
      setInquiries(inquiries.map(inq => 
        inq.id === selectedInquiry.id 
          ? { ...inq, status: '처리완료' }
          : inq
      ));
      alert(`${selectedInquiry.name}님에게 답변이 성공적으로 전송되었습니다.\n\n실제 이메일 전송을 위해서는 Supabase 연결이 필요합니다.`);
      closeReplyModal();
    } catch (error) {
      console.error('Reply sending error:', error);
      alert('답변 전송 중 오류가 발생했습니다. 다시 시도해주세요.');
    }
  };

  // 로그인 처리
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!loginForm.email || !loginForm.password) {
      alert('이메일과 비밀번호를 입력해주세요.');
      return;
    }

    // 승인된 회원가입 신청 목록에서 해당 이메일 확인
    const approvedUser = signupRequests.find(request => 
      request.email === loginForm.email && request.status === '승인완료'
    );

    if (!approvedUser) {
      alert('승인되지 않은 계정이거나 존재하지 않는 계정입니다. 회원가입 신청 후 관리자 승인을 받아주세요.');
      return;
    }

    // 승인된 사용자 로그인 처리
    const userData = {
      id: `user_${approvedUser.id}`,
      name: approvedUser.name,
      email: approvedUser.email,
      organization: approvedUser.organization,
      department: approvedUser.department,
      position: approvedUser.position,
      status: '승인완료'
    };
    
    setUser(userData);
    setIsLoggedIn(true);
    setShowLoginModal(false);
    setLoginForm({ email: '', password: '' });
    
    // 로그인 정보를 로컬 스토리지에 저장
    localStorage.setItem('loggedInUser', JSON.stringify(userData));
    
    alert(`${approvedUser.name}님, 환영합니다!`);
  };

  // 로그아웃 처리
  const handleLogout = () => {
    setUser(null);
    setIsLoggedIn(false);
    // 로컬 스토리지에서 로그인 정보 제거
    localStorage.removeItem('loggedInUser');
    alert('로그아웃되었습니다.');
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Skip Link */}
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-blue-600 text-white px-4 py-2 rounded">
        메인 콘텐츠로 건너뛰기
      </a>

      {/* Header */}
      <header className="bg-slate-800 text-white sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                Nuclear Code Academy
              </h1>
            </div>
            
            <div className="flex items-center space-x-4">
              {/* Desktop Navigation */}
              <nav className="hidden md:flex space-x-8">
                <button 
                  onClick={() => scrollToSection('hero')}
                  className="hover:text-blue-300 transition-colors cursor-pointer"
                >
                  홈
                </button>
                <button 
                  onClick={() => scrollToSection('online-education')}
                  className="hover:text-blue-300 transition-colors cursor-pointer"
                >
                  온라인 교육 신청
                </button>
                <button 
                  onClick={() => window.REACT_APP_NAVIGATE('/video-payment')}
                  className="hover:text-blue-300 transition-colors cursor-pointer"
                >
                  동영상 유료 시청
                </button>
                <button 
                  onClick={() => scrollToSection('group-education')}
                  className="hover:text-blue-300 transition-colors cursor-pointer"
                >
                  집체교육 신청
                </button>
                <button 
                  onClick={() => scrollToSection('support-center')}
                  className="hover:text-blue-300 transition-colors cursor-pointer"
                >
                  학습지원센터
                </button>
                <button 
                  onClick={() => scrollToSection('mypage')}
                  className="hover:text-blue-300 transition-colors cursor-pointer"
                >
                  마이페이지
                </button>
              </nav>

              {/* Login/User Menu */}
              {!isLoggedIn ? (
                <button
                  onClick={() => setShowLoginModal(true)}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2"
                >
                  <i className="ri-user-line text-sm"></i>
                  <span>로그인</span>
                </button>
              ) : (
                <div className="flex items-center space-x-3">
                  <div className="text-sm">
                    <span className="text-blue-300">안녕하세요, </span>
                    <span className="font-medium">{user.name}님</span>
                  </div>
                  <button
                    onClick={handleLogout}
                    className="bg-gray-600 hover:bg-gray-700 text-white px-3 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                  >
                    로그아웃
                  </button>
                </div>
              )}

              {/* Admin Button */}
              <button
                onClick={openAdminPanel}
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2 ${
                  isAdminBlocked 
                    ? 'bg-gray-500 text-gray-300 cursor-not-allowed' 
                    : 'bg-red-600 hover:bg-red-700 text-white'
                }`}
                disabled={isAdminBlocked}
              >
                <i className={`ri-${isAdminBlocked ? 'lock' : 'admin'}-line text-sm`}></i>
                <span>{isAdminBlocked ? '차단됨' : '관리자'}</span>
              </button>

              {/* Mobile menu button */}
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="md:hidden p-2 cursor-pointer"
                aria-label="메뉴 열기"
              >
                <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {mobileMenuOpen && (
            <nav className="md:hidden pb-4">
              <div className="flex flex-col space-y-2">
                <button 
                  onClick={() => scrollToSection('hero')}
                  className="text-left py-2 hover:text-blue-300 transition-colors cursor-pointer"
                >
                  홈
                </button>
                <button 
                  onClick={() => scrollToSection('online-education')}
                  className="text-left py-2 hover:text-blue-300 transition-colors cursor-pointer"
                >
                  온라인 교육 신청
                </button>
                <button 
                  onClick={() => window.REACT_APP_NAVIGATE('/video-payment')}
                  className="text-left py-2 hover:text-blue-300 transition-colors cursor-pointer"
                >
                  동영상 유료 시청
                </button>
                <button 
                  onClick={() => scrollToSection('group-education')}
                  className="text-left py-2 hover:text-blue-300 transition-colors cursor-pointer"
                >
                  집체교육 신청
                </button>
                <button 
                  onClick={() => scrollToSection('support-center')}
                  className="text-left py-2 hover:text-blue-300 transition-colors cursor-pointer"
                >
                  학습지원센터
                </button>
                <button 
                  onClick={() => scrollToSection('mypage')}
                  className="text-left py-2 hover:text-blue-300 transition-colors cursor-pointer"
                >
                  마이페이지
                </button>
                
                {/* Mobile Login/Logout */}
                {!isLoggedIn ? (
                  <button 
                    onClick={() => setShowLoginModal(true)}
                    className="text-left py-2 text-blue-300 hover:text-blue-200 transition-colors cursor-pointer"
                  >
                    로그인
                  </button>
                ) : (
                  <div className="py-2">
                    <div className="text-blue-300 text-sm mb-2">{user.name}님</div>
                    <button 
                      onClick={handleLogout}
                      className="text-left text-gray-300 hover:text-gray-200 transition-colors cursor-pointer"
                    >
                      로그아웃
                    </button>
                  </div>
                )}
                
                <button 
                  onClick={openAdminPanel}
                  className={`text-left py-2 transition-colors cursor-pointer ${
                    isAdminBlocked 
                      ? 'text-gray-400 cursor-not-allowed' 
                      : 'text-red-300 hover:text-red-200'
                  }`}
                  disabled={isAdminBlocked}
                >
                  {isAdminBlocked ? '관리자 (차단됨)' : '관리자'}
                </button>
              </div>
            </nav>
          )}
        </div>
      </header>

      {/* Admin Login Modal */}
      {showAdminLogin && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-md w-full">
            <div className="flex justify-between items-center p-6 border-b">
              <h3 className="text-2xl font-semibold text-gray-900">관리자 인증</h3>
              <button
                onClick={() => setShowAdminLogin(false)}
                className="text-gray-500 hover:text-gray-700 cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
            
            {/* 권한자 표시 */}
            <div className="px-6 pt-2">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                <div className="flex items-center">
                  <i className="ri-shield-user-line text-blue-600 text-lg mr-2"></i>
                  <div>
                    <p className="text-sm font-medium text-blue-800">시스템 관리자</p>
                    <p className="text-xs text-blue-700">
                      권한자: <span className="font-bold">{ADMIN_CREDENTIALS.authorizedUser}</span>님 전용
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            <form onSubmit={handleAdminLogin} className="p-6">
              <div className="mb-4">
                <label htmlFor="admin-email" className="block text-sm font-medium text-gray-700 mb-2">
                  관리자 이메일 *
                </label>
                <input
                  type="email"
                  id="admin-email"
                  value={adminLoginForm.email}
                  onChange={(e) => setAdminLoginForm({...adminLoginForm, email: e.target.value})}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                  placeholder="관리자 이메일을 입력하세요"
                />
              </div>
              
              <div className="mb-6">
                <label htmlFor="admin-password" className="block text-sm font-medium text-gray-700 mb-2">
                  관리자 비밀번호 *
                </label>
                <input
                  type="password"
                  id="admin-password"
                  value={adminLoginForm.password}
                  onChange={(e) => setAdminLoginForm({...adminLoginForm, password: e.target.value})}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                  placeholder="관리자 비밀번호를 입력하세요"
                />
              </div>
              
              {/* 보안 경고 */}
              <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
                <div className="flex items-start">
                  <i className="ri-shield-line text-red-600 text-lg mr-2 mt-0.5"></i>
                  <div>
                    <p className="text-sm font-medium text-red-800 mb-1">보안 안내</p>
                    <p className="text-xs text-red-700 mb-2">
                      관리자 권한은 <span className="font-bold">{ADMIN_CREDENTIALS.authorizedUser}</span>님만 보유합니다.
                    </p>
                    <ul className="text-xs text-red-700 space-y-1">
                      <li>• 3회 실패 시 30분간 접근 차단</li>
                      <li>• 모든 접근 시도가 기록됩니다</li>
                      <li>• 무단 접근 시 법적 조치 가능</li>
                      <li>• 권한 없는 접근은 즉시 신고됩니다</li>
                    </ul>
                  </div>
                </div>
              </div>
              
              {/* 로그인 시도 횟수 표시 */}
              {adminLoginAttempts > 0 && (
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4">
                  <div className="flex items-center">
                    <i className="ri-alert-line text-yellow-600 text-sm mr-2"></i>
                    <p className="text-sm text-yellow-800">
                      ⚠️ 무단 접근 시도: {adminLoginAttempts}/{MAX_LOGIN_ATTEMPTS}회
                      <br />
                      <span className="text-xs">권한자: {ADMIN_CREDENTIALS.authorizedUser}님 전용 시스템</span>
                    </p>
                  </div>
                </div>
              )}
              
              <div className="flex space-x-3">
                <button
                  type="button"
                  onClick={() => setShowAdminLogin(false)}
                  className="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-700 py-3 rounded-lg text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
                >
                  취소
                </button>
                <button
                  type="submit"
                  className="flex-1 bg-red-600 hover:bg-red-700 text-white py-3 rounded-lg text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
                >
                  관리자 인증
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Login Modal */}
      {showLoginModal && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-md w-full max-h-[90vh] overflow-hidden">
            <div className="flex justify-between items-center p-6 border-b">
              <h3 className="text-2xl font-semibold text-gray-900">
                {activeLoginTab === 'login' ? '로그인' : '회원가입'}
              </h3>
              <button
                onClick={() => {
                  setShowLoginModal(false);
                  setActiveLoginTab('login');
                }}
                className="text-gray-500 hover:text-gray-700 cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
            
            {/* Tab Navigation */}
            <div className="border-b">
              <nav className="flex">
                <button
                  onClick={() => setActiveLoginTab('login')}
                  className={`flex-1 py-3 px-4 text-center font-medium text-sm cursor-pointer ${
                    activeLoginTab === 'login'
                      ? 'border-b-2 border-blue-500 text-blue-600 bg-blue-50'
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  로그인
                </button>
                <button
                  onClick={() => setActiveLoginTab('signup')}
                  className={`flex-1 py-3 px-4 text-center font-medium text-sm cursor-pointer ${
                    activeLoginTab === 'signup'
                      ? 'border-b-2 border-blue-500 text-blue-600 bg-blue-50'
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  회원가입
                </button>
              </nav>
            </div>

            <div className="overflow-y-auto max-h-[calc(90vh-140px)]">
              {/* 로그인 탭 */}
              {activeLoginTab === 'login' && (
                <form onSubmit={handleLogin} className="p-6">
                  <div className="mb-4">
                    <label htmlFor="login-email" className="block text-sm font-medium text-gray-700 mb-2">
                      이메일 *
                    </label>
                    <input
                      type="email"
                      id="login-email"
                      value={loginForm.email}
                      onChange={(e) => setLoginForm({...loginForm, email: e.target.value})}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="이메일을 입력하세요"
                    />
                  </div>
                  
                  <div className="mb-6">
                    <label htmlFor="login-password" className="block text-sm font-medium text-gray-700 mb-2">
                      비밀번호 *
                    </label>
                    <input
                      type="password"
                      id="login-password"
                      value={loginForm.password}
                      onChange={(e) => setLoginForm({...loginForm, password: e.target.value})}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="비밀번호를 입력하세요"
                    />
                  </div>
                  
                  <button
                    type="submit"
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
                  >
                    로그인
                  </button>
                  
                  <div className="mt-4 text-center">
                    <p className="text-sm text-gray-600">
                      계정이 없으신가요? 
                      <button 
                        type="button"
                        onClick={() => setActiveLoginTab('signup')}
                        className="text-blue-600 hover:text-blue-700 ml-1 cursor-pointer"
                      >
                        회원가입
                      </button>
                    </p>
                  </div>
                </form>
              )}

              {/* 회원가입 탭 */}
              {activeLoginTab === 'signup' && (
                <form onSubmit={handleSignup} className="p-6" data-readdy-form>
                  <div className="mb-4">
                    <label htmlFor="signup-name" className="block text-sm font-medium text-gray-700 mb-2">
                      성명 *
                    </label>
                    <input
                      type="text"
                      id="signup-name"
                      name="name"
                      value={signupForm.name}
                      onChange={(e) => setSignupForm({...signupForm, name: e.target.value})}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="성명을 입력하세요"
                    />
                  </div>

                  <div className="mb-4">
                    <label htmlFor="signup-email" className="block text-sm font-medium text-gray-700 mb-2">
                      이메일 *
                    </label>
                    <input
                      type="email"
                      id="signup-email"
                      name="email"
                      value={signupForm.email}
                      onChange={(e) => setSignupForm({...signupForm, email: e.target.value})}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="이메일을 입력하세요"
                    />
                  </div>

                  <div className="mb-4">
                    <label htmlFor="signup-password" className="block text-sm font-medium text-gray-700 mb-2">
                      비밀번호 *
                    </label>
                    <input
                      type="password"
                      id="signup-password"
                      name="password"
                      value={signupForm.password}
                      onChange={(e) => setSignupForm({...signupForm, password: e.target.value})}
                      required
                      minLength={6}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="비밀번호를 입력하세요 (6자 이상)"
                    />
                  </div>

                  <div className="mb-4">
                    <label htmlFor="signup-confirm-password" className="block text-sm font-medium text-gray-700 mb-2">
                      비밀번호 확인 *
                    </label>
                    <input
                      type="password"
                      id="signup-confirm-password"
                      value={signupForm.confirmPassword}
                      onChange={(e) => setSignupForm({...signupForm, confirmPassword: e.target.value})}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="비밀번호를 다시 입력하세요"
                    />
                  </div>

                  <div className="mb-4">
                    <label htmlFor="signup-organization" className="block text-sm font-medium text-gray-700 mb-2">
                      소속기관 *
                    </label>
                    <input
                      type="text"
                      id="signup-organization"
                      name="organization"
                      value={signupForm.organization}
                      onChange={(e) => setSignupForm({...signupForm, organization: e.target.value})}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="소속기관을 입력하세요"
                    />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label htmlFor="signup-department" className="block text-sm font-medium text-gray-700 mb-2">
                        부서 *
                      </label>
                      <input
                        type="text"
                        id="signup-department"
                        name="department"
                        value={signupForm.department}
                        onChange={(e) => setSignupForm({...signupForm, department: e.target.value})}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                        placeholder="부서명"
                      />
                    </div>
                    <div>
                      <label htmlFor="signup-position" className="block text-sm font-medium text-gray-700 mb-2">
                        직급 *
                      </label>
                      <input
                        type="text"
                        id="signup-position"
                        name="position"
                        value={signupForm.position}
                        onChange={(e) => setSignupForm({...signupForm, position: e.target.value})}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                        placeholder="직급"
                      />
                    </div>
                  </div>

                  <div className="mb-4">
                    <label htmlFor="signup-phone" className="block text-sm font-medium text-gray-700 mb-2">
                      연락처 *
                    </label>
                    <input
                      type="tel"
                      id="signup-phone"
                      name="phone"
                      value={signupForm.phone}
                      onChange={(e) => setSignupForm({...signupForm, phone: e.target.value})}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="연락처를 입력하세요 (예: 01012345678)"
                    />
                  </div>

                  <div className="mb-6">
                    <label htmlFor="signup-reason" className="block text-sm font-medium text-gray-700 mb-2">
                      가입 사유 *
                    </label>
                    <textarea
                      id="signup-reason"
                      name="reason"
                      value={signupForm.reason}
                      onChange={(e) => setSignupForm({...signupForm, reason: e.target.value})}
                      required
                      maxLength={500}
                      rows={3}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                      placeholder="회원가입 사유를 입력하세요 (최대 500자)"
                    ></textarea>
                    <p className="text-xs text-gray-500 mt-1">{signupForm.reason.length}/500자</p>
                  </div>

                  <button
                    type="submit"
                    className="w-full bg-green-600 hover:bg-green-700 text-white py-3 rounded-lg text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
                  >
                    회원가입 신청
                  </button>
                  
                  <div className="mt-4 text-center">
                    <p className="text-sm text-gray-600">
                      이미 계정이 있으신가요? 
                      <button 
                        type="button"
                        onClick={() => setActiveLoginTab('login')}
                        className="text-blue-600 hover:text-blue-700 ml-1 cursor-pointer"
                      >
                        로그인
                      </button>
                    </p>
                  </div>

                  <div className="mt-4 pt-4 border-t">
                    <div className="bg-blue-50 p-3 rounded-lg">
                      <div className="flex items-start">
                        <i className="ri-information-line text-blue-600 text-sm mr-2 mt-0.5"></i>
                        <div>
                          <p className="text-xs text-blue-800 font-medium mb-1">회원가입 안내</p>
                          <p className="text-xs text-blue-700">
                            회원가입 신청 후 관리자 승인을 거쳐 계정이 활성화됩니다. 
                            승인 완료 시 이메일로 안내드립니다.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Admin Panel Modal */}
      {showAdminPanel && isAdminAuthenticated && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-6xl w-full max-h-[90vh] overflow-hidden">
            <div className="flex justify-between items-center p-6 border-b">
              <div className="flex items-center space-x-4">
                <h3 className="text-2xl font-semibold text-gray-900">관리자 패널</h3>
                <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
                  <i className="ri-shield-check-line mr-1"></i>
                  {ADMIN_CREDENTIALS.authorizedUser}님 인증됨
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <div className="text-sm text-gray-600">
                  관리자: {ADMIN_CREDENTIALS.email}
                </div>
                <button
                  onClick={handleAdminLogout}
                  className="bg-gray-600 hover:bg-gray-700 text-white px-3 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                >
                  로그아웃
                </button>
                <button
                  onClick={() => setShowAdminPanel(false)}
                  className="text-gray-500 hover:text-gray-700 cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
            </div>
            
            {/* Tab Navigation */}
            <div className="border-b">
              <nav className="flex space-x-8 px-6">
                <button
                  onClick={() => setActiveAdminTab('inquiries')}
                  className={`py-4 px-1 border-b-2 font-medium text-sm cursor-pointer ${
                    activeAdminTab === 'inquiries'
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  문의 관리
                </button>
                <button
                  onClick={() => setActiveAdminTab('signup-requests')}
                  className={`py-4 px-1 border-b-2 font-medium text-sm cursor-pointer ${
                    activeAdminTab === 'signup-requests'
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  회원가입 승인
                  {signupRequests.filter(req => req.status === '대기중').length > 0 && (
                    <span className="ml-2 bg-red-500 text-white text-xs px-2 py-1 rounded-full">
                      {signupRequests.filter(req => req.status === '대기중').length}
                    </span>
                  )}
                </button>
                <button
                  onClick={() => setActiveAdminTab('secrets')}
                  className={`py-4 px-1 border-b-2 font-medium text-sm cursor-pointer ${
                    activeAdminTab === 'secrets'
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  시크릿 관리
                </button>
              </nav>
            </div>

            <div className="p-6 overflow-y-auto max-h-[calc(90vh-180px)]">
              {/* 문의 관리 탭 */}
              {activeAdminTab === 'inquiries' && (
                <div>
                  <div className="mb-6">
                    <div className="flex justify-between items-center mb-4">
                      <h4 className="text-lg font-semibold">접수된 문의 목록</h4>
                      <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">
                        총 {inquiries.length}건
                      </span>
                    </div>
                    
                    <div className="overflow-x-auto">
                      <table className="w-full border-collapse border border-gray-300">
                        <thead>
                          <tr className="bg-gray-50">
                            <th className="border border-gray-300 px-4 py-3 text-left">번호</th>
                            <th className="border border-gray-300 px-4 py-3 text-left">성명</th>
                            <th className="border border-gray-300 px-4 py-3 text-left">이메일</th>
                            <th className="border border-gray-300 px-4 py-3 text-left">문의내용</th>
                            <th className="border border-gray-300 px-4 py-3 text-left">접수일</th>
                            <th className="border border-gray-300 px-4 py-3 text-left">처리상태</th>
                            <th className="border border-gray-300 px-4 py-3 text-left">액션</th>
                          </tr>
                        </thead>
                        <tbody>
                          {inquiries.map((inquiry) => (
                            <tr key={inquiry.id} className="hover:bg-gray-50">
                              <td className="border border-gray-300 px-4 py-3">{inquiry.id}</td>
                              <td className="border border-gray-300 px-4 py-3">{inquiry.name}</td>
                              <td className="border border-gray-300 px-4 py-3">{inquiry.email}</td>
                              <td className="border border-gray-300 px-4 py-3 max-w-xs truncate">
                                {inquiry.message}
                              </td>
                              <td className="border border-gray-300 px-4 py-3">{inquiry.date}</td>
                              <td className="border border-gray-300 px-4 py-3">
                                <span className={`px-2 py-1 rounded-full text-xs ${
                                  inquiry.status === '미처리' 
                                    ? 'bg-red-100 text-red-800' 
                                    : 'bg-green-100 text-green-800'
                                }`}>
                                  {inquiry.status}
                                </span>
                              </td>
                              <td className="border border-gray-300 px-4 py-3">
                                <div className="flex space-x-2">
                                  <button 
                                    onClick={() => openReplyModal(inquiry)}
                                    className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded text-xs cursor-pointer whitespace-nowrap"
                                  >
                                    답변
                                  </button>
                                  <button 
                                    onClick={() => {
                                      setInquiries(inquiries.map(inq => 
                                        inq.id === inquiry.id 
                                          ? { ...inq, status: inq.status === '미처리' ? '처리완료' : '미처리' }
                                          : inq
                                      ));
                                    }}
                                    className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-xs cursor-pointer whitespace-nowrap"
                                  >
                                    상태변경
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h5 className="font-semibold mb-2">통계</h5>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div className="bg-white p-3 rounded">
                        <p className="text-sm text-gray-600">전체 문의</p>
                        <p className="text-2xl font-bold text-blue-600">{inquiries.length}</p>
                      </div>
                      <div className="bg-white p-3 rounded">
                        <p className="text-sm text-gray-600">미처리</p>
                        <p className="text-2xl font-bold text-red-600">
                          {inquiries.filter(inq => inq.status === '미처리').length}
                        </p>
                      </div>
                      <div className="bg-white p-3 rounded">
                        <p className="text-sm text-gray-600">처리완료</p>
                        <p className="text-2xl font-bold text-green-600">
                          {inquiries.filter(inq => inq.status === '처리완료').length}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* 회원가입 승인 탭 */}
              {activeAdminTab === 'signup-requests' && (
                <div>
                  <div className="mb-6">
                    <div className="flex justify-between items-center mb-4">
                      <h4 className="text-lg font-semibold">회원가입 신청 목록</h4>
                      <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">
                        총 {signupRequests.length}건
                      </span>
                    </div>
                    
                    <div className="overflow-x-auto">
                      <table className="w-full border-collapse border border-gray-300">
                        <thead>
                          <tr className="bg-gray-50">
                            <th className="border border-gray-300 px-4 py-3 text-left">번호</th>
                            <th className="border border-gray-300 px-4 py-3 text-left">성명</th>
                            <th className="border border-gray-300 px-4 py-3 text-left">이메일</th>
                            <th className="border border-gray-300 px-4 py-3 text-left">소속기관</th>
                            <th className="border border-gray-300 px-4 py-3 text-left">부서</th>
                            <th className="border border-gray-300 px-4 py-3 text-left">직급</th>
                            <th className="border border-gray-300 px-4 py-3 text-left">연락처</th>
                            <th className="border border-gray-300 px-4 py-3 text-left">신청일</th>
                            <th className="border border-gray-300 px-4 py-3 text-left">상태</th>
                            <th className="border border-gray-300 px-4 py-3 text-left">액션</th>
                          </tr>
                        </thead>
                        <tbody>
                          {signupRequests.map((request) => (
                            <tr key={request.id} className="hover:bg-gray-50">
                              <td className="border border-gray-300 px-4 py-3">{request.id}</td>
                              <td className="border border-gray-300 px-4 py-3">{request.name}</td>
                              <td className="border border-gray-300 px-4 py-3">{request.email}</td>
                              <td className="border border-gray-300 px-4 py-3">{request.organization}</td>
                              <td className="border border-gray-300 px-4 py-3">{request.department}</td>
                              <td className="border border-gray-300 px-4 py-3">{request.position}</td>
                              <td className="border border-gray-300 px-4 py-3">{request.phone}</td>
                              <td className="border border-gray-300 px-4 py-3">{request.requestDate}</td>
                              <td className="border border-gray-300 px-4 py-3">
                                <span className={`px-2 py-1 rounded-full text-xs ${
                                  request.status === '대기중' 
                                    ? 'bg-yellow-100 text-yellow-800' 
                                    : request.status === '승인완료'
                                    ? 'bg-green-100 text-green-800'
                                    : 'bg-red-100 text-red-800'
                                }`}>
                                  {request.status}
                                </span>
                              </td>
                              <td className="border border-gray-300 px-4 py-3">
                                {request.status === '대기중' ? (
                                  <div className="flex space-x-2">
                                    <button 
                                      onClick={() => approveSignupRequest(request.id)}
                                      className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-xs cursor-pointer whitespace-nowrap"
                                    >
                                      승인
                                    </button>
                                    <button 
                                      onClick={() => rejectSignupRequest(request.id)}
                                      className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded text-xs cursor-pointer whitespace-nowrap"
                                    >
                                      거부
                                    </button>
                                  </div>
                                ) : (
                                  <div className="text-xs">
                                    <div>{request.status === '승인완료' ? request.approvedDate : request.rejectedDate}</div>
                                    <div>{request.status === '승인완료' ? request.approvedBy : request.rejectedBy}</div>
                                    {request.status === '거부됨' && (
                                      <div className="text-red-600">{request.rejectionReason}</div>
                                    )}
                                  </div>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}

              {/* 시크릿 관리 탭 */}
              {activeAdminTab === 'secrets' && (
                <div>
                  <div className="mb-6">
                    <h4 className="text-lg font-semibold mb-4">시크릿 정보 관리</h4>
                    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
                      <div className="flex">
                        <i className="ri-information-line text-yellow-400 text-xl mr-3"></i>
                        <div>
                          <p className="text-sm text-yellow-700">
                            시크릿 정보는 브라우저의 localStorage에 저장됩니다. 
                            실제 운영 환경에서는 더 안전한 방법으로 관리해야 합니다.
                          </p>
                        </div>
                      </div>
                    </div>
                    
                    <div className="space-y-4">
                      <div>
                        <label htmlFor="supabase-url" className="block text-sm font-medium text-gray-700 mb-2">
                          SUPABASE_URL
                        </label>
                        <input
                          type="text"
                          id="supabase-url"
                          value={secrets.SUPABASE_URL}
                          onChange={(e) => setSecrets({...secrets, SUPABASE_URL: e.target.value})}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                          placeholder="https://your-project.supabase.co"
                        />
                      </div>
                      
                      <div>
                        <label htmlFor="supabase-anon-key" className="block text-sm font-medium text-gray-700 mb-2">
                          SUPABASE_ANON_KEY
                        </label>
                        <input
                          type="text"
                          id="supabase-anon-key"
                          value={secrets.SUPABASE_ANON_KEY}
                          onChange={(e) => setSecrets({...secrets, SUPABASE_ANON_KEY: e.target.value})}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                          placeholder="SUPABASE_ANON_KEY"
                        />
                      </div>
                      
                      <div>
                        <label htmlFor="resend-api-key" className="block text-sm font-medium text-gray-700 mb-2">
                          RESEND_API_KEY
                        </label>
                        <input
                          type="text"
                          id="resend-api-key"
                          value={secrets.RESEND_API_KEY}
                          onChange={(e) => setSecrets({...secrets, RESEND_API_KEY: e.target.value})}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                          placeholder="RESEND_API_KEY"
                        />
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex space-x-4">
                    <button
                      onClick={saveSecrets}
                      className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg text-sm font-semibold transition-colors cursor-pointer"
                    >
                      저장
                    </button>
                    <button
                      onClick={loadSecrets}
                      className="bg-gray-600 hover:bg-gray-700 text-white px-6 py-3 rounded-lg text-sm font-semibold transition-colors cursor-pointer"
                    >
                      불러오기
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Reply Modal */}
      {showReplyModal && selectedInquiry && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-hidden">
            <div className="flex justify-between items-center p-6 border-b">
              <h3 className="text-xl font-semibold text-gray-900">문의 답변</h3>
              <button
                onClick={closeReplyModal}
                className="text-gray-500 hover:text-gray-700 cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
            
            <div className="p-6 overflow-y-auto max-h-[calc(90vh-180px)]">
              <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
                  <div>
                    <span className="text-sm font-medium text-gray-600">문의자:</span>
                    <span className="ml-2 text-sm">{selectedInquiry.name}</span>
                  </div>
                  <div>
                    <span className="text-sm font-medium text-gray-600">이메일:</span>
                    <span className="ml-2 text-sm">{selectedInquiry.email}</span>
                  </div>
                  <div>
                    <span className="text-sm font-medium text-gray-600">접수일:</span>
                    <span className="ml-2 text-sm">{selectedInquiry.date}</span>
                  </div>
                  <div>
                    <span className="text-sm font-medium text-gray-600">처리상태:</span>
                    <span className="ml-2 text-sm">
                      <span className={`px-2 py-1 rounded-full text-xs ${
                        selectedInquiry.status === '미처리' 
                          ? 'bg-red-100 text-red-800' 
                          : 'bg-green-100 text-green-800'
                      }`}>
                        {selectedInquiry.status}
                      </span>
                    </span>
                  </div>
                </div>
                <div>
                  <span className="text-sm font-medium text-gray-600">문의내용:</span>
                  <div className="mt-2 p-3 bg-white border border-gray-200 rounded text-sm">
                    {selectedInquiry.message}
                  </div>
                </div>
              </div>
              
              <div className="mb-6">
                <label htmlFor="reply-content" className="block text-sm font-medium text-gray-700 mb-2">
                  답변 내용 *
                </label>
                <textarea
                  id="reply-content"
                  value={replyContent}
                  onChange={(e) => setReplyContent(e.target.value)}
                  required
                  rows={8}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                  placeholder="답변 내용을 입력하세요"
                ></textarea>
              </div>
              
              <div className="flex justify-end space-x-3">
                <button
                  onClick={closeReplyModal}
                  className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-6 py-3 rounded-lg text-sm font-semibold transition-colors cursor-pointer"
                >
                  취소
                </button>
                <button
                  onClick={sendReply}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg text-sm font-semibold transition-colors cursor-pointer"
                >
                  답변 전송
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Video Modal */}
      {selectedCourse && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-hidden">
            <div className="flex justify-between items-center p-6 border-b">
              <h3 className="text-xl font-semibold text-gray-900">{selectedCourse.title}</h3>
              <button
                onClick={closeVideoModal}
                className="text-gray-500 hover:text-gray-700 cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
            
            <div className="p-6">
              <div className="aspect-video mb-6">
                <iframe
                  src={`https://www.youtube.com/embed/${selectedCourse.videoId}`}
                  title={selectedCourse.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full rounded-lg"
                ></iframe>
              </div>
              
              <div className="mb-4">
                <span className="inline-block bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
                  {selectedCourse.category}
                </span>
              </div>
              
              <p className="text-gray-700 mb-6">{selectedCourse.description}</p>
              
              <div className="flex justify-end">
                <button
                  onClick={closeVideoModal}
                  className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-6 py-3 rounded-lg text-sm font-semibold transition-colors cursor-pointer"
                >
                  닫기
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <section id="hero" className="bg-gradient-to-r from-blue-800 to-indigo-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            원자력 전문 교육 플랫폼
          </h1>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            원자력발전소 설계, 시험, 품질보증, 사이버보안 분야의 전문 지식을 온라인으로 배울 수 있습니다
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button
              onClick={() => scrollToSection('online-education')}
              className="bg-white text-blue-800 hover:bg-gray-100 px-8 py-3 rounded-lg font-semibold transition-colors cursor-pointer"
            >
              온라인 교육 신청
            </button>
            <button
              onClick={() => scrollToSection('group-education')}
              className="bg-transparent border-2 border-white hover:bg-white hover:text-blue-800 px-8 py-3 rounded-lg font-semibold transition-colors cursor-pointer"
            >
              집체교육 신청
            </button>
          </div>
        </div>
      </section>

      {/* Online Education Section */}
      <section id="online-education" className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">온라인 교육 신청</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              원자력 발전소 관련 전문 지식을 온라인에서 편리하게 학습하세요
            </p>
          </div>
          
          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-2 mb-8">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveFilter(category)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer ${
                  activeFilter === category
                    ? 'bg-blue-600 text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
          
          {/* Course Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredCourses.map((course) => (
              <div 
                key={course.id} 
                className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow cursor-pointer"
                onClick={() => openVideoModal(course)}
              >
                <div className="p-6">
                  <div className="mb-4 flex items-center justify-between">
                    <span className="inline-block bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-medium">
                      {course.category}
                    </span>
                    <div className="flex items-center space-x-2">
                      {course.isPaid && (
                        <span className="inline-block bg-orange-100 text-orange-800 px-2 py-1 rounded-full text-xs font-medium">
                          유료
                        </span>
                      )}
                      {course.price && (
                        <span className="inline-block bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-bold">
                          {course.price.toLocaleString()}원
                        </span>
                      )}
                    </div>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">{course.title}</h3>
                  <p className="text-gray-600 mb-4">{course.description}</p>
                  <div className="flex items-center justify-between">
                    <button className="text-blue-600 hover:text-blue-800 font-medium text-sm flex items-center">
                      {course.isPaid ? '결제 후 시청' : '강의보기'}
                      <i className="ri-arrow-right-line ml-1 text-sm"></i>
                    </button>
                    {course.price && (
                      <div className="text-right">
                        <div className="text-lg font-bold text-gray-900">{course.price.toLocaleString()}원</div>
                        <div className="text-xs text-gray-500">1회 시청권</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Group Education Section */}
      <section id="group-education" className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">집체교육 신청</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              전문 강사와 함께하는 집체교육을 신청하세요
            </p>
          </div>
          
          <div className="bg-white rounded-lg shadow-md p-8 max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">교육 프로그램</h3>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-green-500 mt-1 mr-2"></i>
                    <span>EMC 시험 기술 심화 과정 (3일)</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-green-500 mt-1 mr-2"></i>
                    <span>품질보증 엔지니어 양성 과정 (5일)</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-green-500 mt-1 mr-2"></i>
                    <span>사이버보안 인증 준비 과정 (2일)</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-green-500 mt-1 mr-2"></i>
                    <span>원자력 전기설비 규정 해설 (1일)</span>
                  </li>
                </ul>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">신청 방법</h3>
                <ol className="space-y-3">
                  <li className="flex items-start">
                    <span className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-medium mr-2 flex-shrink-0">1</span>
                    <span>아래 신청서 작성 후 제출</span>
                  </li>
                  <li className="flex items-start">
                    <span className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-medium mr-2 flex-shrink-0">2</span>
                    <span>관리자 확인 후 이메일 회신</span>
                  </li>
                  <li className="flex items-start">
                    <span className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-medium mr-2 flex-shrink-0">3</span>
                    <span>교육비 입금 및 입실 안내</span>
                  </li>
                </ol>
              </div>
            </div>
            
            <div className="mt-8 pt-8 border-t">
              <form 
                onSubmit={handleContactSubmit}
                className="grid grid-cols-1 md:grid-cols-2 gap-6"
                data-readdy-form
              >
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    성명 *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="성명을 입력하세요"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    이메일 *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="이메일을 입력하세요"
                  />
                </div>
                
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                    연락처 *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="연락처를 입력하세요 (예: 01012345678)"
                  />
                </div>
                
                <div>
                  <label htmlFor="organization" className="block text-sm font-medium text-gray-700 mb-2">
                    소속기관 *
                  </label>
                  <input
                    type="text"
                    id="organization"
                    name="organization"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="소속기관을 입력하세요"
                  />
                </div>
                
                <div className="md:col-span-2">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                    교육 신청 내용 *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows={4}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                    placeholder="관심 있는 교육 프로그램과 사유를 입력하세요"
                  ></textarea>
                </div>
                
                <div className="md:col-span-2">
                  <button
                    type="submit"
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg text-sm font-semibold transition-colors cursor-pointer"
                  >
                    집체교육 신청하기
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Support Center Section */}
      <section id="support-center" className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">학습지원센터</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              궁금한 점이 있으시면 언제든지 문의해주세요
            </p>
          </div>
          
          <div className="bg-white rounded-lg shadow-md p-8 max-w-4xl mx-auto">
            <form 
              onSubmit={handleContactSubmit}
              className="grid grid-cols-1 md:grid-cols-2 gap-6"
              data-readdy-form
            >
              <div>
                <label htmlFor="support-name" className="block text-sm font-medium text-gray-700 mb-2">
                  성명 *
                </label>
                <input
                  type="text"
                  id="support-name"
                  name="name"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="성명을 입력하세요"
                />
              </div>
              
              <div>
                <label htmlFor="support-email" className="block text-sm font-medium text-gray-700 mb-2">
                  이메일 *
                </label>
                <input
                  type="email"
                  id="support-email"
                  name="email"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="이메일을 입력하세요"
                />
              </div>
              
              <div>
                <label htmlFor="support-phone" className="block text-sm font-medium text-gray-700 mb-2">
                  연락처
                </label>
                <input
                  type="tel"
                  id="support-phone"
                  name="phone"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="연락처를 입력하세요 (예: 01012345678)"
                />
              </div>
              
              <div>
                <label htmlFor="support-category" className="block text-sm font-medium text-gray-700 mb-2">
                  문의 유형 *
                </label>
                <select
                  id="support-category"
                  name="category"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm pr-8"
                >
                  <option value="">선택해주세요</option>
                  <option value="course">강의 관련</option>
                  <option value="payment">결제 관련</option>
                  <option value="account">계정 관련</option>
                  <option value="technical">기술 지원</option>
                  <option value="other">기타</option>
                </select>
              </div>
              
              <div className="md:col-span-2">
                <label htmlFor="support-message" className="block text-sm font-medium text-gray-700 mb-2">
                  문의 내용 *
                </label>
                <textarea
                  id="support-message"
                  name="message"
                  required
                  rows={6}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                  placeholder="문의 내용을 상세히 입력해주세요"
                ></textarea>
              </div>
              
              <div className="md:col-span-2">
                <button
                  type="submit"
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg text-sm font-semibold transition-colors cursor-pointer"
                >
                  문의하기
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-800 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                Nuclear Code Academy
              </h3>
              <p className="text-gray-400 text-sm">
                원자력 전문 교육 플랫폼
              </p>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">서비스</h4>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li><button onClick={() => scrollToSection('online-education')} className="hover:text-white cursor-pointer">온라인 교육</button></li>
                <li><button onClick={() => scrollToSection('group-education')} className="hover:text-white cursor-pointer">집체교육</button></li>
                <li><button onClick={() => window.REACT_APP_NAVIGATE('/video-payment')} className="hover:text-white cursor-pointer">유료 시청</button></li>
                <li><button onClick={() => scrollToSection('support-center')} className="hover:text-white cursor-pointer">학습지원센터</button></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">문의</h4>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li className="flex items-start">
                  <i className="ri-mail-line mr-2 mt-1 text-sm"></i>
                  <span>contact@nca.kr</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-phone-line mr-2 mt-1 text-sm"></i>
                  <span>02-123-4567</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-map-pin-line mr-2 mt-1 text-sm"></i>
                  <span>서울특별시 강남구 테헤란로 123</span>
                </li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">팔로우</h4>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-white cursor-pointer">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white cursor-pointer">
                  <i className="ri-twitter-fill text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white cursor-pointer">
                  <i className="ri-instagram-fill text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white cursor-pointer">
                  <i className="ri-youtube-fill text-xl"></i>
                </a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400 text-sm">
            <p>&copy; {currentYear} Nuclear Code Academy. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}